/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { PostTablesRoles200, PostTablesRolesBody } from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Returns user management roles
 * @summary Return user management roles
 */
export const getRoles = (signal?: AbortSignal) => {
  return apiClient<unknown>({ url: `/roles`, method: 'GET', signal });
};

export const getGetRolesQueryKey = () => {
  return [`/roles`] as const;
};

export const getGetRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoles>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoles>>> = ({
    signal,
  }) => getRoles(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoles>>
>;
export type GetRolesQueryError = unknown;

export function useGetRoles<
  TData = Awaited<ReturnType<typeof getRoles>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoles<
  TData = Awaited<ReturnType<typeof getRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoles<
  TData = Awaited<ReturnType<typeof getRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return user management roles
 */

export function useGetRoles<
  TData = Awaited<ReturnType<typeof getRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates user management roles
 * @summary Update user management roles
 */
export const postRoles = (signal?: AbortSignal) => {
  return apiClient<unknown>({ url: `/roles`, method: 'POST', signal });
};

export const getPostRolesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRoles>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRoles>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postRoles'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRoles>>,
    void
  > = () => {
    return postRoles();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRoles>>
>;

export type PostRolesMutationError = unknown;

/**
 * @summary Update user management roles
 */
export const usePostRoles = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRoles>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRoles>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes user management roles
 * @summary Delete user management roles
 */
export const deleteRolesRoleKey = (roleKey: string) => {
  return apiClient<unknown>({ url: `/roles/${roleKey}`, method: 'DELETE' });
};

export const getDeleteRolesRoleKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRolesRoleKey>>,
    TError,
    { roleKey: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRolesRoleKey>>,
  TError,
  { roleKey: string },
  TContext
> => {
  const mutationKey = ['deleteRolesRoleKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRolesRoleKey>>,
    { roleKey: string }
  > = (props) => {
    const { roleKey } = props ?? {};

    return deleteRolesRoleKey(roleKey);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRolesRoleKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRolesRoleKey>>
>;

export type DeleteRolesRoleKeyMutationError = unknown;

/**
 * @summary Delete user management roles
 */
export const useDeleteRolesRoleKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRolesRoleKey>>,
      TError,
      { roleKey: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRolesRoleKey>>,
  TError,
  { roleKey: string },
  TContext
> => {
  const mutationOptions = getDeleteRolesRoleKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns specific user management role
 * @summary Return specific user management role
 */
export const getRolesRoleKey = (roleKey: string, signal?: AbortSignal) => {
  return apiClient<unknown>({
    url: `/roles/${roleKey}`,
    method: 'GET',
    signal,
  });
};

export const getGetRolesRoleKeyQueryKey = (roleKey: string) => {
  return [`/roles/${roleKey}`] as const;
};

export const getGetRolesRoleKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getRolesRoleKey>>,
  TError = unknown,
>(
  roleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRolesRoleKey>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRolesRoleKeyQueryKey(roleKey);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRolesRoleKey>>> = ({
    signal,
  }) => getRolesRoleKey(roleKey, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roleKey,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRolesRoleKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRolesRoleKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRolesRoleKey>>
>;
export type GetRolesRoleKeyQueryError = unknown;

export function useGetRolesRoleKey<
  TData = Awaited<ReturnType<typeof getRolesRoleKey>>,
  TError = unknown,
>(
  roleKey: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRolesRoleKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolesRoleKey>>,
          TError,
          Awaited<ReturnType<typeof getRolesRoleKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRolesRoleKey<
  TData = Awaited<ReturnType<typeof getRolesRoleKey>>,
  TError = unknown,
>(
  roleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRolesRoleKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolesRoleKey>>,
          TError,
          Awaited<ReturnType<typeof getRolesRoleKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRolesRoleKey<
  TData = Awaited<ReturnType<typeof getRolesRoleKey>>,
  TError = unknown,
>(
  roleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRolesRoleKey>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return specific user management role
 */

export function useGetRolesRoleKey<
  TData = Awaited<ReturnType<typeof getRolesRoleKey>>,
  TError = unknown,
>(
  roleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRolesRoleKey>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRolesRoleKeyQueryOptions(roleKey, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates specific user management role
 * @summary Update specific user management role
 */
export const patchRolesRoleKey = (roleKey: string) => {
  return apiClient<unknown>({ url: `/roles/${roleKey}`, method: 'PATCH' });
};

export const getPatchRolesRoleKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRolesRoleKey>>,
    TError,
    { roleKey: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchRolesRoleKey>>,
  TError,
  { roleKey: string },
  TContext
> => {
  const mutationKey = ['patchRolesRoleKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchRolesRoleKey>>,
    { roleKey: string }
  > = (props) => {
    const { roleKey } = props ?? {};

    return patchRolesRoleKey(roleKey);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchRolesRoleKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchRolesRoleKey>>
>;

export type PatchRolesRoleKeyMutationError = unknown;

/**
 * @summary Update specific user management role
 */
export const usePatchRolesRoleKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchRolesRoleKey>>,
      TError,
      { roleKey: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchRolesRoleKey>>,
  TError,
  { roleKey: string },
  TContext
> => {
  const mutationOptions = getPatchRolesRoleKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Rewrites specific user management role
 * @summary Rewrite specific user management role
 */
export const putRolesRoleKey = (roleKey: string) => {
  return apiClient<unknown>({ url: `/roles/${roleKey}`, method: 'PUT' });
};

export const getPutRolesRoleKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putRolesRoleKey>>,
    TError,
    { roleKey: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putRolesRoleKey>>,
  TError,
  { roleKey: string },
  TContext
> => {
  const mutationKey = ['putRolesRoleKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putRolesRoleKey>>,
    { roleKey: string }
  > = (props) => {
    const { roleKey } = props ?? {};

    return putRolesRoleKey(roleKey);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutRolesRoleKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putRolesRoleKey>>
>;

export type PutRolesRoleKeyMutationError = unknown;

/**
 * @summary Rewrite specific user management role
 */
export const usePutRolesRoleKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putRolesRoleKey>>,
      TError,
      { roleKey: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putRolesRoleKey>>,
  TError,
  { roleKey: string },
  TContext
> => {
  const mutationOptions = getPutRolesRoleKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * User management roles database used for user management policies
 * @summary RBAC - User Management Roles
 */
export const postTablesRoles = (
  postTablesRolesBody: PostTablesRolesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesRoles200>({
    url: `/tables/roles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesRolesBody,
    signal,
  });
};

export const getPostTablesRolesQueryKey = (
  postTablesRolesBody: PostTablesRolesBody,
) => {
  return [`/tables/roles`, postTablesRolesBody] as const;
};

export const getPostTablesRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesRoles>>,
  TError = unknown,
>(
  postTablesRolesBody: PostTablesRolesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesRoles>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPostTablesRolesQueryKey(postTablesRolesBody);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postTablesRoles>>> = ({
    signal,
  }) => postTablesRoles(postTablesRolesBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesRoles>>
>;
export type PostTablesRolesQueryError = unknown;

export function usePostTablesRoles<
  TData = Awaited<ReturnType<typeof postTablesRoles>>,
  TError = unknown,
>(
  postTablesRolesBody: PostTablesRolesBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesRoles>>,
          TError,
          Awaited<ReturnType<typeof postTablesRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesRoles<
  TData = Awaited<ReturnType<typeof postTablesRoles>>,
  TError = unknown,
>(
  postTablesRolesBody: PostTablesRolesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesRoles>>,
          TError,
          Awaited<ReturnType<typeof postTablesRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesRoles<
  TData = Awaited<ReturnType<typeof postTablesRoles>>,
  TError = unknown,
>(
  postTablesRolesBody: PostTablesRolesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary RBAC - User Management Roles
 */

export function usePostTablesRoles<
  TData = Awaited<ReturnType<typeof postTablesRoles>>,
  TError = unknown,
>(
  postTablesRolesBody: PostTablesRolesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesRolesQueryOptions(
    postTablesRolesBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
